/**
 * 401s (and medicaid 429s) the axios interceptor must let reject so the
 * caller can handle them. Every other 401 is swallowed into a never-settling
 * promise (and may log the user out). Magic-link login and the medicaid
 * identity gate both use 401 as a normal, expected response.
 */
export function isMedicaidApplyRequest(url: string | undefined): boolean {
  return !!url && url.includes('/medicaid/apply/')
}

export function isExpectedUnauthenticated401(url: string | undefined): boolean {
  if (!url)
    return false

  return url.includes('/token-login') || isMedicaidApplyRequest(url)
}
